import { render, staticRenderFns } from "./InputTelephone.vue?vue&type=template&id=a0be8bce"
import script from "./InputTelephone.vue?vue&type=script&lang=js"
export * from "./InputTelephone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Label: require('/home/runner/work/platform/platform/packages/client/src/components/elements/form/label/Label.vue').default,Select: require('/home/runner/work/platform/platform/packages/client/src/components/elements/form/select/Select.vue').default,Input: require('/home/runner/work/platform/platform/packages/client/src/components/elements/form/input/Input.vue').default})
